import { ForwardedRef, forwardRef, ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './LandingSection.module.css';

type Props = {
  className?: string;
  children?: ReactNode;
  id?: string;
};

export const LandingSection = forwardRef(
  ({ className, id, children }: Props, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <section id={id} className={cx(className, styles.root)} ref={ref}>
        <div className={styles.content}>{children}</div>
      </section>
    );
  },
);

LandingSection.displayName = 'LandingSection';
